var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.998 4.02539L52.4981 17.0158V42.9965L29.998 55.9869L7.49805 42.9965V17.0158L29.998 4.02539ZM12.498 22.5005L12.498 40.1098L27.498 48.7699V31.1607L12.498 22.5005ZM47.498 22.5006L32.498 31.1607V48.7699L47.4981 40.1098L47.498 22.5006ZM29.998 9.79889L15.248 18.3148L29.998 26.8307L44.7481 18.3148L29.998 9.79889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.9e56545c92deb7628044eb5fcf1aa8be.svg";
export { ForwardRef as ReactComponent };